module.exports = __webpack_public_path__ + "img/help_home.e669ea8f.png";